import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import * as browserCheck from '../../utils/browserCheck.js';

class BrowserWarning extends Component {
    constructor(props, context) {
        super(props, context);
        //for server rendering, return true to match the most likely client result
        this.state = 
        { 
            browserSupported: !browserCheck.canUseDom() || (browserCheck.canUseDom() && $('html').hasClass('inlinesvg'))
        };
        this.dismiss = this.dismiss.bind(this);
    }
    componentDidMount() {
        if(browserCheck.canUseDom()) {
            if (!this.state.browserSupported) {
                $('body').addClass('showbrowser');
            }
            else {
                $('body').removeClass('showbrowser');
            }            
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.state.browserSupported != nextState.browserSupported;
    }

    dismiss(e) {
        e.preventDefault();    
        $('body').removeClass('showbrowser'); 
    }

    render() {        
        const browserSupported = this.state.browserSupported;
        if(!browserSupported) {
            return (
                <div className="browser transition2">
                    <div className="inner">
                        <h3>Browser not supported</h3>
                        <p>Unfortunately, the browser you are using is not supported.</p>
                        <p>You can proceed, but it won't be pretty.</p>
                        <ul>
                            <li>the page layout may look a little strange</li>
                            <li>icons may not appear</li>
                            <li>stuff won't work (technical description)</li>
                        </ul>
                        <p>We suggest upgrading your browser, but you can proceed at your own risk...!</p>
                        <div className="browser-btns">
                            <a href="http://whatbrowser.org/" target="_blank" className="btn btn-outline transition">Upgrade my browser</a>
                            <a id="btnClearBrowser" href="#" className="btn btn-outline transition btn-clearbrowser" onClick={this.dismiss}>Proceed anyway</a>
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div />
            );
        }
    }
}

BrowserWarning.propTypes = {
    //addAnimation: PropTypes.func.isRequired
};

export default BrowserWarning;